// import React, { useEffect, useState } from "react";
// import {
//   Container,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Typography,
//   Skeleton,
//   Alert,
//   Button,
//   Box,
//   Chip,
//   useTheme,
//   useMediaQuery,
//   TablePagination,
//   IconButton,
//   Tooltip,
// } from "@mui/material";
// import {
//   Search,
//   Refresh,
//   AccessTime,
//   LocationOn,
//   Category,
//   ShoppingCart,
// } from "@mui/icons-material";
// import { createTheme, ThemeProvider } from "@mui/material/styles";
// import { useParams } from "react-router-dom";

// // Medstown theme
// const medstownTheme = createTheme({
//   palette: {
//     primary: {
//       main: "#1d5244",
//       light: "#4a7c59",
//       dark: "#0f2920",
//     },
//     secondary: {
//       main: "#2e7d32",
//     },
//     background: {
//       default: "#f8f9fa",
//       paper: "#ffffff",
//     },
//   },
//   typography: {
//     fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
//     h5: {
//       fontWeight: 600,
//       fontSize: "1.5rem",
//     },
//     h6: {
//       fontWeight: 600,
//       fontSize: "1.25rem",
//     },
//   },
//   components: {
//     MuiTableCell: {
//       styleOverrides: {
//         head: {
//           backgroundColor: "#f8f9fa",
//           fontWeight: 600,
//           color: "#374151",
//         },
//       },
//     },
//     MuiChip: {
//       styleOverrides: {
//         root: {
//           fontWeight: 500,
//         },
//       },
//     },
//   },
// });

// // Loading Skeleton Component
// const LoadingSkeleton = () => (
//   <TableContainer component={Paper}>
//     <Table>
//       <TableHead>
//         <TableRow>
//           {["Search Term", "Type", "Location", "Results", "Date & Time"].map(
//             (header) => (
//               <TableCell key={header}>
//                 <Skeleton variant="text" width={80} height={24} />
//               </TableCell>
//             )
//           )}
//         </TableRow>
//       </TableHead>
//       <TableBody>
//         {[...Array(8)].map((_, index) => (
//           <TableRow key={index}>
//             <TableCell>
//               <Skeleton variant="text" width={120} height={20} />
//             </TableCell>
//             <TableCell>
//               <Skeleton
//                 variant="rectangular"
//                 width={80}
//                 height={24}
//                 sx={{ borderRadius: 1 }}
//               />
//             </TableCell>
//             <TableCell>
//               <Skeleton variant="text" width={60} height={20} />
//             </TableCell>
//             <TableCell>
//               <Skeleton
//                 variant="rectangular"
//                 width={50}
//                 height={24}
//                 sx={{ borderRadius: 1 }}
//               />
//             </TableCell>
//             <TableCell>
//               <Skeleton variant="text" width={140} height={20} />
//             </TableCell>
//           </TableRow>
//         ))}
//       </TableBody>
//     </Table>
//   </TableContainer>
// );

// // Mobile Card Component for responsive design
// const MobileCard = ({ item }) => (
//   <Paper sx={{ p: 2, mb: 2, borderRadius: 2 }}>
//     <Box display="flex" alignItems="center" mb={1}>
//       <Search sx={{ mr: 1, color: "primary.main", fontSize: 20 }} />
//       <Typography variant="h6" sx={{ fontWeight: 600, color: "text.primary" }}>
//         {item.search}
//       </Typography>
//     </Box>

//     <Box display="flex" flexWrap="wrap" gap={1} mb={2}>
//       <Chip
//         icon={<Category sx={{ fontSize: 16 }} />}
//         label={item.searchType}
//         size="small"
//         color="primary"
//         variant="outlined"
//       />
//       <Chip
//         icon={<LocationOn sx={{ fontSize: 16 }} />}
//         label={item.pincode}
//         size="small"
//         color="secondary"
//         variant="outlined"
//       />
//       <Chip
//         icon={<ShoppingCart sx={{ fontSize: 16 }} />}
//         label={`${item.resulted_products} results`}
//         size="small"
//         color={item.resulted_products > 0 ? "success" : "error"}
//       />
//     </Box>

//     <Box display="flex" alignItems="center" color="text.secondary">
//       <AccessTime sx={{ fontSize: 16, mr: 0.5 }} />
//       <Typography variant="body2">
//         {new Date(item.searchedAt).toLocaleString("en-IN", {
//           day: "2-digit",
//           month: "short",
//           year: "numeric",
//           hour: "2-digit",
//           minute: "2-digit",
//           hour12: true,
//         })}
//       </Typography>
//     </Box>
//   </Paper>
// );

// export default function SearchHistory({ userId }) {
//   //   const { userId } = useParams();
//   const [searchHistory, setSearchHistory] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [totalCount, setTotalCount] = useState(0);

//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("md"));

//   const fetchSearchHistory = async (currentPage = 0, limit = 10) => {
//     setLoading(true);
//     setError(null);

//     try {
//       const baseUrl = "https://api.medstown.com";
//       const targetUserId = userId || "USER2771853d-1eff-4d7b-ba80-0cc4a3007299";
//       const response = await fetch(
//         `${baseUrl}/api/admin-controls/user/search-history/${targetUserId}?page=${
//           currentPage + 1
//         }&limit=${limit}`,
//         {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }

//       const result = await response.json();

//       if (result.success && result.data) {
//         const sortedList = (result.data.list || []).sort(
//           (a, b) => new Date(b.searchedAt) - new Date(a.searchedAt)
//         );
//         setSearchHistory(sortedList);
//         setTotalCount(result.data.totalCount || 0);
//       } else {
//         throw new Error(result.message || "Failed to fetch search history");
//       }
//     } catch (err) {
//       console.error("Error fetching search history:", err);
//       setError(
//         err.message || "An error occurred while fetching search history"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchSearchHistory(page, rowsPerPage);
//   }, [userId, page, rowsPerPage]);

//   const handleRetry = () => {
//     fetchSearchHistory(page, rowsPerPage);
//   };

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   const getResultChipColor = (count) => {
//     if (count === 0) return "error";
//     if (count < 10) return "warning";
//     return "success";
//   };

//   if (loading) {
//     return (
//       <ThemeProvider theme={medstownTheme}>
//         <Container maxWidth="xl" sx={{ py: 3 }}>
//           <Paper sx={{ p: 3, mb: 3, bgcolor: "primary.main", color: "white" }}>
//             <Box
//               display="flex"
//               alignItems="center"
//               justifyContent="space-between"
//             >
//               <Box display="flex" alignItems="center">
//                 <Search sx={{ mr: 2, fontSize: 32 }} />
//                 <Box>
//                   <Skeleton variant="text" width={200} height={32} />
//                   <Skeleton variant="text" width={150} height={20} />
//                 </Box>
//               </Box>
//             </Box>
//           </Paper>
//           <LoadingSkeleton />
//         </Container>
//       </ThemeProvider>
//     );
//   }

//   if (error) {
//     return (
//       <ThemeProvider theme={medstownTheme}>
//         <Container maxWidth="xl" sx={{ py: 3 }}>
//           <Alert
//             severity="error"
//             sx={{ mb: 3, borderRadius: 2 }}
//             action={
//               <Button
//                 color="inherit"
//                 size="small"
//                 onClick={handleRetry}
//                 startIcon={<Refresh />}
//               >
//                 Retry
//               </Button>
//             }
//           >
//             <Typography variant="h6" gutterBottom>
//               Failed to Load Search History
//             </Typography>
//             {error}
//           </Alert>
//         </Container>
//       </ThemeProvider>
//     );
//   }

//   return (
//     <ThemeProvider theme={medstownTheme}>
//       <Container maxWidth="xl" sx={{ py: 3 }}>
//         {/* Header */}
//         <Paper sx={{ p: 3, mb: 3, bgcolor: "primary.main", color: "white" }}>
//           <Box
//             display="flex"
//             alignItems="center"
//             justifyContent="space-between"
//           >
//             <Box display="flex" alignItems="center">
//               <Search sx={{ mr: 2, fontSize: 32 }} />
//               <Box>
//                 <Typography
//                   variant={isMobile ? "h6" : "h5"}
//                   sx={{ fontWeight: 700 }}
//                 >
//                   Search History
//                 </Typography>
//                 <Typography variant="body2" sx={{ opacity: 0.9 }}>
//                   {totalCount} total searches found
//                 </Typography>
//               </Box>
//             </Box>
//             <Tooltip title="Refresh Data">
//               <IconButton onClick={handleRetry} sx={{ color: "white" }}>
//                 <Refresh />
//               </IconButton>
//             </Tooltip>
//           </Box>
//         </Paper>

//         {searchHistory.length === 0 ? (
//           <Alert severity="info" sx={{ borderRadius: 2 }}>
//             <Typography variant="h6" gutterBottom>
//               No search history found
//             </Typography>
//             This user hasn't performed any searches yet.
//           </Alert>
//         ) : (
//           <>
//             {/* Mobile View */}
//             {isMobile ? (
//               <Box>
//                 {searchHistory.map((item) => (
//                   <MobileCard key={item._id} item={item} />
//                 ))}
//               </Box>
//             ) : (
//               /* Desktop Table View */
//               <TableContainer component={Paper} sx={{ borderRadius: 2 }}>
//                 <Table>
//                   <TableHead>
//                     <TableRow>
//                       <TableCell>
//                         <Box display="flex" alignItems="center">
//                           <Search sx={{ mr: 1, fontSize: 18 }} />
//                           Search Term
//                         </Box>
//                       </TableCell>
//                       <TableCell>
//                         <Box display="flex" alignItems="center">
//                           <Category sx={{ mr: 1, fontSize: 18 }} />
//                           Type
//                         </Box>
//                       </TableCell>
//                       <TableCell>
//                         <Box display="flex" alignItems="center">
//                           <LocationOn sx={{ mr: 1, fontSize: 18 }} />
//                           Location
//                         </Box>
//                       </TableCell>
//                       <TableCell>
//                         <Box display="flex" alignItems="center">
//                           <ShoppingCart sx={{ mr: 1, fontSize: 18 }} />
//                           Results
//                         </Box>
//                       </TableCell>
//                       <TableCell>
//                         <Box display="flex" alignItems="center">
//                           <AccessTime sx={{ mr: 1, fontSize: 18 }} />
//                           Date & Time
//                         </Box>
//                       </TableCell>
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {searchHistory.map((item) => (
//                       <TableRow key={item._id} hover>
//                         <TableCell>
//                           <Typography variant="body1" sx={{ fontWeight: 500 }}>
//                             {item.search}
//                           </Typography>
//                         </TableCell>
//                         <TableCell>
//                           <Chip
//                             label={item.searchType}
//                             size="small"
//                             color="primary"
//                             variant="outlined"
//                           />
//                         </TableCell>
//                         <TableCell>
//                           <Typography variant="body2" color="text.secondary">
//                             {item.pincode}
//                           </Typography>
//                         </TableCell>
//                         <TableCell>
//                           <Chip
//                             label={item?.resulted_products || 0}
//                             size="small"
//                             color={getResultChipColor(item.resulted_products)}
//                           />
//                         </TableCell>
//                         <TableCell>
//                           <Typography variant="body2" color="text.secondary">
//                             {new Date(item.searchedAt).toLocaleString("en-IN", {
//                               day: "2-digit",
//                               month: "short",
//                               year: "numeric",
//                               hour: "2-digit",
//                               minute: "2-digit",
//                               hour12: true,
//                             })}
//                           </Typography>
//                         </TableCell>
//                       </TableRow>
//                     ))}
//                   </TableBody>
//                 </Table>
//               </TableContainer>
//             )}

//             {/* Pagination */}
//             <TablePagination
//               component="div"
//               count={totalCount}
//               page={page}
//               onPageChange={handleChangePage}
//               rowsPerPage={rowsPerPage}
//               onRowsPerPageChange={handleChangeRowsPerPage}
//               rowsPerPageOptions={[5, 10, 25, 50]}
//               sx={{ mt: 2 }}
//             />
//           </>
//         )}
//       </Container>
//     </ThemeProvider>
//   );
// }



import React, { useEffect, useState } from "react";
import {
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Skeleton,
  Alert,
  Button,
  Box,
  Chip,
  useTheme,
  useMediaQuery,
  TablePagination,
  IconButton,
  Tooltip,
  Card,
  CardContent,
  Stack,
  Divider,
  Fade,
  Zoom,
  Avatar,
  Grid,
  Badge,
  TextField,
  InputAdornment,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import {
  Search,
  Refresh,
  AccessTime,
  LocationOn,
  Category,
  ShoppingCart,
  TrendingUp,
  Analytics,
  FilterList,
  Sort,
  ViewList,
  ViewModule,
  Timeline,
  Info,
  Clear,
} from "@mui/icons-material";
import { createTheme, ThemeProvider } from "@mui/material/styles";

// Enhanced modern theme
const medstownTheme = createTheme({
  palette: {
    primary: {
      main: "#2563eb",
      light: "#60a5fa",
      dark: "#1d4ed8",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#10b981",
      light: "#34d399",
      dark: "#047857",
    },
    success: {
      main: "#059669",
      light: "#10b981",
      dark: "#047857",
    },
    warning: {
      main: "#f59e0b",
      light: "#fbbf24",
      dark: "#d97706",
    },
    error: {
      main: "#ef4444",
      light: "#f87171",
      dark: "#dc2626",
    },
    info: {
      main: "#3b82f6",
      light: "#93c5fd",
      dark: "#1e40af",
    },
    background: {
      default: "#f8fafc",
      paper: "#ffffff",
    },
    text: {
      primary: "#0f172a",
      secondary: "#64748b",
    },
  },
  typography: {
    fontFamily: '"Inter", "Segoe UI", "Roboto", sans-serif',
    h4: {
      fontWeight: 700,
      fontSize: "2rem",
      lineHeight: 1.2,
    },
    h5: {
      fontWeight: 600,
      fontSize: "1.5rem",
      lineHeight: 1.3,
    },
    h6: {
      fontWeight: 600,
      fontSize: "1.25rem",
      lineHeight: 1.4,
    },
    body1: {
      fontWeight: 500,
      fontSize: "1rem",
      lineHeight: 1.5,
    },
    body2: {
      fontWeight: 400,
      fontSize: "0.875rem",
      lineHeight: 1.4,
      color: "#64748b",
    },
    caption: {
      fontSize: "0.75rem",
      fontWeight: 500,
      color: "#94a3b8",
    },
  },
  shape: {
    borderRadius: 16,
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 20,
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
          border: "1px solid #f1f5f9",
          transition: "all 0.3s ease-in-out",
          "&:hover": {
            transform: "translateY(-2px)",
            boxShadow: "0 8px 30px rgba(0, 0, 0, 0.12)",
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 20,
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: "#f8fafc",
          fontWeight: 600,
          color: "#374151",
          fontSize: "0.875rem",
          borderBottom: "2px solid #e2e8f0",
        },
        body: {
          fontSize: "0.875rem",
          borderBottom: "1px solid #f1f5f9",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          fontWeight: 600,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          textTransform: "none",
          fontWeight: 600,
        },
      },
    },
  },
});

// Enhanced Loading Skeleton
const LoadingSkeleton = () => (
  <Container maxWidth="xl" sx={{ py: 4 }}>
    {/* Header Skeleton */}
    <Paper sx={{ p: 4, mb: 4 }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Stack direction="row" alignItems="center" spacing={2}>
          <Skeleton variant="circular" width={60} height={60} />
          <Box>
            <Skeleton variant="text" width={200} height={32} />
            <Skeleton variant="text" width={150} height={20} />
          </Box>
        </Stack>
        <Skeleton variant="rectangular" width={120} height={40} sx={{ borderRadius: 2 }} />
      </Stack>
    </Paper>

    {/* Stats Cards Skeleton */}
    <Grid container spacing={3} sx={{ mb: 4 }}>
      {[1, 2, 3, 4].map((i) => (
        <Grid item xs={6} md={3} key={i}>
          <Card>
            <CardContent>
              <Stack direction="row" alignItems="center" spacing={2}>
                <Skeleton variant="circular" width={48} height={48} />
                <Box flex={1}>
                  <Skeleton variant="text" width={80} height={20} />
                  <Skeleton variant="text" width={60} height={32} />
                </Box>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>

    {/* Table Skeleton */}
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            {["Search Term", "Type", "Location", "Results", "Date & Time"].map((header) => (
              <TableCell key={header}>
                <Skeleton variant="text" width={100} height={24} />
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {[...Array(8)].map((_, index) => (
            <TableRow key={index}>
              <TableCell><Skeleton variant="text" width={150} height={20} /></TableCell>
              <TableCell><Skeleton variant="rectangular" width={80} height={24} sx={{ borderRadius: 2 }} /></TableCell>
              <TableCell><Skeleton variant="text" width={60} height={20} /></TableCell>
              <TableCell><Skeleton variant="rectangular" width={50} height={24} sx={{ borderRadius: 2 }} /></TableCell>
              <TableCell><Skeleton variant="text" width={140} height={20} /></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </Container>
);

// Stats Card Component
const StatsCard = ({ icon, title, value, color = "primary", trend }) => (
  <Card>
    <CardContent sx={{ p: 3 }}>
      <Stack direction="row" alignItems="center" spacing={2}>
        <Box
          sx={{
            p: 1.5,
            borderRadius: "16px",
            bgcolor: `${color}.main`,
            color: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 56,
            height: 56,
          }}
        >
          {icon}
        </Box>
        <Box flex={1}>
          <Typography variant="caption" sx={{ display: "block", mb: 0.5 }}>
            {title}
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: 700, color: "text.primary" }}>
            {value}
          </Typography>
          {trend && (
            <Typography variant="caption" color="success.main" sx={{ display: "flex", alignItems: "center", mt: 0.5 }}>
              <TrendingUp sx={{ fontSize: 14, mr: 0.5 }} />
              {trend}
            </Typography>
          )}
        </Box>
      </Stack>
    </CardContent>
  </Card>
);

// Enhanced Mobile Card Component
const MobileCard = ({ item, index }) => (
  <Zoom in timeout={600 + index * 100}>
    <Card sx={{ mb: 2 }}>
      <CardContent sx={{ p: 3 }}>
        {/* Search Term Header */}
        <Stack direction="row" alignItems="flex-start" spacing={2} sx={{ mb: 2 }}>
          <Avatar
            sx={{
              bgcolor: "primary.main",
              width: 40,
              height: 40,
            }}
          >
            <Search sx={{ fontSize: 20 }} />
          </Avatar>
          <Box flex={1}>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5 }}>
              {item.search}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {new Date(item.searchedAt).toLocaleDateString("en-IN", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })}
            </Typography>
          </Box>
          <Chip
            label={item.resulted_products || 0}
            size="small"
            color={getResultChipColor(item.resulted_products)}
            sx={{ fontWeight: 600 }}
          />
        </Stack>

        <Divider sx={{ my: 2 }} />

        {/* Details Grid */}
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Stack spacing={1}>
              <Typography variant="caption" sx={{ fontWeight: 600 }}>
                Search Type
              </Typography>
              <Chip
                icon={<Category sx={{ fontSize: 16 }} />}
                label={item.searchType}
                size="small"
                color="primary"
                variant="outlined"
              />
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Stack spacing={1}>
              <Typography variant="caption" sx={{ fontWeight: 600 }}>
                Location
              </Typography>
              <Chip
                icon={<LocationOn sx={{ fontSize: 16 }} />}
                label={item.pincode}
                size="small"
                color="secondary"
                variant="outlined"
              />
            </Stack>
          </Grid>
        </Grid>

        {/* Timestamp */}
        <Box sx={{ mt: 2, pt: 2, borderTop: "1px solid #f1f5f9" }}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <AccessTime sx={{ fontSize: 16, color: "text.secondary" }} />
            <Typography variant="body2" color="text.secondary">
              {new Date(item.searchedAt).toLocaleString("en-IN", {
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
              })}
            </Typography>
          </Stack>
        </Box>
      </CardContent>
    </Card>
  </Zoom>
);

// Helper function for result chip colors
const getResultChipColor = (count) => {
  if (count === 0) return "error";
  if (count < 10) return "warning";
  return "success";
};

// Helper function to get search type icon
const getSearchTypeIcon = (type) => {
  switch (type?.toLowerCase()) {
    case "product":
      return <ShoppingCart sx={{ fontSize: 16 }} />;
    case "category":
      return <Category sx={{ fontSize: 16 }} />;
    default:
      return <Search sx={{ fontSize: 16 }} />;
  }
};

export default function SearchHistory({ userId }) {
  const [searchHistory, setSearchHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [viewMode, setViewMode] = useState("table"); // table or cards
  const [searchFilter, setSearchFilter] = useState("");
  const [typeFilter, setTypeFilter] = useState("");

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isTablet = useMediaQuery(theme.breakpoints.down("lg"));

  // Calculate stats
  const stats = {
    totalSearches: totalCount,
    uniqueTypes: [...new Set(searchHistory.map(item => item.searchType))].length,
    avgResults: Math.round(searchHistory.reduce((sum, item) => sum + (item.resulted_products || 0), 0) / searchHistory.length) || 0,
    recentSearches: searchHistory.filter(item => 
      new Date(item.searchedAt) > new Date(Date.now() - 24 * 60 * 60 * 1000)
    ).length,
  };

  const fetchSearchHistory = async (currentPage = 0, limit = 10) => {
    setLoading(true);
    setError(null);

    try {
      const baseUrl = "https://api.medstown.com";
      const targetUserId = userId || "USER2771853d-1eff-4d7b-ba80-0cc4a3007299";
      const response = await fetch(
        `${baseUrl}/api/admin-controls/user/search-history/${targetUserId}?page=${
          currentPage + 1
        }&limit=${limit}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (result.success && result.data) {
        const sortedList = (result.data.list || []).sort(
          (a, b) => new Date(b.searchedAt) - new Date(a.searchedAt)
        );
        setSearchHistory(sortedList);
        setTotalCount(result.data.totalCount || 0);
      } else {
        throw new Error(result.message || "Failed to fetch search history");
      }
    } catch (err) {
      console.error("Error fetching search history:", err);
      setError(
        err.message || "An error occurred while fetching search history"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSearchHistory(page, rowsPerPage);
  }, [userId, page, rowsPerPage]);

  const handleRetry = () => {
    fetchSearchHistory(page, rowsPerPage);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Filter data based on search and type filters
  const filteredData = searchHistory.filter(item => {
    const matchesSearch = item.search.toLowerCase().includes(searchFilter.toLowerCase());
    const matchesType = !typeFilter || item.searchType === typeFilter;
    return matchesSearch && matchesType;
  });

  const uniqueTypes = [...new Set(searchHistory.map(item => item.searchType))];

  if (loading) {
    return (
      <ThemeProvider theme={medstownTheme}>
        <Box sx={{ bgcolor: "background.default", minHeight: "100vh" }}>
          <LoadingSkeleton />
        </Box>
      </ThemeProvider>
    );
  }

  if (error) {
    return (
      <ThemeProvider theme={medstownTheme}>
        <Container maxWidth="xl" sx={{ py: 4 }}>
          <Fade in>
            <Alert
              severity="error"
              sx={{ borderRadius: 3 }}
              action={
                <Button
                  color="inherit"
                  size="small"
                  onClick={handleRetry}
                  startIcon={<Refresh />}
                >
                  Retry
                </Button>
              }
            >
              <Typography variant="h6">Failed to Load Search History</Typography>
              {error}
            </Alert>
          </Fade>
        </Container>
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={medstownTheme}>
      <Box sx={{ bgcolor: "background.default", minHeight: "100vh", py: 4 }}>
        <Container maxWidth="xl">
          {/* Enhanced Header */}
          <Fade in timeout={600}>
            <Paper
              sx={{
                p: 4,
                mb: 4,
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                color: "white",
                position: "relative",
                overflow: "hidden",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  top: 0,
                  right: 0,
                  width: "200px",
                  height: "200px",
                  background: "rgba(255,255,255,0.1)",
                  borderRadius: "50%",
                  transform: "translate(50%, -50%)",
                },
              }}
            >
              <Stack
                direction={isMobile ? "column" : "row"}
                alignItems={isMobile ? "center" : "flex-start"}
                justifyContent="space-between"
                sx={{ position: "relative", zIndex: 1 }}
              >
                <Stack direction="row" alignItems="center" spacing={3}>
                  <Avatar
                    sx={{
                      width: 80,
                      height: 80,
                      bgcolor: "rgba(255,255,255,0.2)",
                      backdropFilter: "blur(10px)",
                    }}
                  >
                    <Analytics sx={{ fontSize: 40 }} />
                  </Avatar>
                  <Box textAlign={isMobile ? "center" : "left"}>
                    <Typography variant="h4" sx={{ mb: 1, color: "white" }}>
                      Search Analytics
                    </Typography>
                    <Typography variant="body1" sx={{ opacity: 0.9, color: "white" }}>
                      {totalCount} total searches • User activity insights
                    </Typography>
                  </Box>
                </Stack>

                <Stack direction="row" spacing={2} sx={{ mt: isMobile ? 2 : 0 }}>
                  <Tooltip title="Switch View">
                    <IconButton
                      onClick={() => setViewMode(viewMode === "table" ? "cards" : "table")}
                      sx={{
                        color: "white",
                        bgcolor: "rgba(255,255,255,0.1)",
                        backdropFilter: "blur(10px)",
                        "&:hover": { bgcolor: "rgba(255,255,255,0.2)" },
                      }}
                    >
                      {viewMode === "table" ? <ViewModule /> : <ViewList />}
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Refresh Data">
                    <IconButton
                      onClick={handleRetry}
                      sx={{
                        color: "white",
                        bgcolor: "rgba(255,255,255,0.1)",
                        backdropFilter: "blur(10px)",
                        "&:hover": { bgcolor: "rgba(255,255,255,0.2)" },
                      }}
                    >
                      <Refresh />
                    </IconButton>
                  </Tooltip>
                </Stack>
              </Stack>
            </Paper>
          </Fade>

          {/* Stats Cards */}
          {searchHistory.length > 0 && (
            <Fade in timeout={800}>
              <Grid container spacing={3} sx={{ mb: 4 }}>
                <Grid item xs={6} md={3}>
                  <StatsCard
                    icon={<Search />}
                    title="Total Searches"
                    value={stats.totalSearches}
                    color="primary"
                  />
                </Grid>
                <Grid item xs={6} md={3}>
                  <StatsCard
                    icon={<Category />}
                    title="Search Types"
                    value={stats.uniqueTypes}
                    color="secondary"
                  />
                </Grid>
                <Grid item xs={6} md={3}>
                  <StatsCard
                    icon={<ShoppingCart />}
                    title="Avg Results"
                    value={stats.avgResults}
                    color="warning"
                  />
                </Grid>
                <Grid item xs={6} md={3}>
                  <StatsCard
                    icon={<Timeline />}
                    title="Recent (24h)"
                    value={stats.recentSearches}
                    color="info"
                    trend="+12%"
                  />
                </Grid>
              </Grid>
            </Fade>
          )}

          {searchHistory.length === 0 ? (
            <Fade in timeout={1000}>
              <Alert severity="info" sx={{ borderRadius: 3, p: 4 }}>
                <Stack alignItems="center" spacing={2}>
                  <Search sx={{ fontSize: 64, color: "info.main", opacity: 0.5 }} />
                  <Typography variant="h6">No Search History Found</Typography>
                  <Typography variant="body2" textAlign="center">
                    This user hasn't performed any searches yet. Search history will appear here once they start using the app.
                  </Typography>
                </Stack>
              </Alert>
            </Fade>
          ) : (
            <>
              {/* Filters */}
              <Fade in timeout={1000}>
                <Paper sx={{ p: 3, mb: 3 }}>
                  <Stack
                    direction={isMobile ? "column" : "row"}
                    spacing={2}
                    alignItems={isMobile ? "stretch" : "center"}
                  >
                    <TextField
                      placeholder="Search terms..."
                      value={searchFilter}
                      onChange={(e) => setSearchFilter(e.target.value)}
                      size="small"
                      sx={{ minWidth: 200 }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Search sx={{ fontSize: 20 }} />
                          </InputAdornment>
                        ),
                        endAdornment: searchFilter && (
                          <InputAdornment position="end">
                            <IconButton
                              size="small"
                              onClick={() => setSearchFilter("")}
                            >
                              <Clear sx={{ fontSize: 16 }} />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                    
                    <FormControl size="small" sx={{ minWidth: 150 }}>
                      <InputLabel>Search Type</InputLabel>
                      <Select
                        value={typeFilter}
                        onChange={(e) => setTypeFilter(e.target.value)}
                        label="Search Type"
                      >
                        <MenuItem value="">All Types</MenuItem>
                        {uniqueTypes.map(type => (
                          <MenuItem key={type} value={type}>{type}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <Box flex={1} />
                    
                    <Typography variant="body2" color="text.secondary">
                      Showing {filteredData.length} of {totalCount} searches
                    </Typography>
                  </Stack>
                </Paper>
              </Fade>

              {/* Content */}
              {isMobile || viewMode === "cards" ? (
                /* Mobile/Card View */
                <Box>
                  {filteredData.map((item, index) => (
                    <MobileCard key={item._id} item={item} index={index} />
                  ))}
                </Box>
              ) : (
                /* Desktop Table View */
                <Fade in timeout={1200}>
                  <TableContainer component={Paper} sx={{ borderRadius: 3 }}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>
                            <Stack direction="row" alignItems="center" spacing={1}>
                              <Search sx={{ fontSize: 18 }} />
                              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                Search Term
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell>
                            <Stack direction="row" alignItems="center" spacing={1}>
                              <Category sx={{ fontSize: 18 }} />
                              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                Type
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell>
                            <Stack direction="row" alignItems="center" spacing={1}>
                              <LocationOn sx={{ fontSize: 18 }} />
                              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                Location
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell>
                            <Stack direction="row" alignItems="center" spacing={1}>
                              <ShoppingCart sx={{ fontSize: 18 }} />
                              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                Results
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell>
                            <Stack direction="row" alignItems="center" spacing={1}>
                              <AccessTime sx={{ fontSize: 18 }} />
                              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                Date & Time
                              </Typography>
                            </Stack>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {filteredData.map((item, index) => (
                          <TableRow
                            key={item._id}
                            hover
                            sx={{
                              "&:hover": {
                                bgcolor: "rgba(37, 99, 235, 0.04)",
                              },
                            }}
                          >
                            <TableCell>
                              <Stack direction="row" alignItems="center" spacing={2}>
                                <Avatar
                                  sx={{
                                    width: 32,
                                    height: 32,
                                    bgcolor: "primary.main",
                                    fontSize: 14,
                                  }}
                                >
                                  {index + 1}
                                </Avatar>
                                <Box>
                                  <Typography variant="body1" sx={{ fontWeight: 600 }}>
                                    {item.search}
                                  </Typography>
                                </Box>
                              </Stack>
                            </TableCell>
                            <TableCell>
                              <Chip
                                icon={getSearchTypeIcon(item.searchType)}
                                label={item.searchType}
                                size="small"
                                color="primary"
                                variant="outlined"
                                sx={{ fontWeight: 600 }}
                              />
                            </TableCell>
                            <TableCell>
                              <Chip
                                icon={<LocationOn sx={{ fontSize: 14 }} />}
                                label={item.pincode}
                                size="small"
                                color="secondary"
                                variant="outlined"
                              />
                            </TableCell>
                            <TableCell>
                              <Badge
                                // badgeContent={
                                //   item.resulted_products > 50 ? "50+" : item.resulted_products
                                // }
                                color={getResultChipColor(item.resulted_products)}
                                max={50}
                              >
                                <Chip
                                  label={item.resulted_products || 0}
                                  size="small"
                                  color={getResultChipColor(item.resulted_products)}
                                  sx={{ fontWeight: 600 }}
                                />
                              </Badge>
                            </TableCell>
                            <TableCell>
                              <Stack spacing={0.5}>
                                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                  {new Date(item.searchedAt).toLocaleDateString("en-IN", {
                                    day: "2-digit",
                                    month: "short",
                                    year: "numeric",
                                  })}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  {new Date(item.searchedAt).toLocaleTimeString("en-IN", {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: true,
                                  })}
                                </Typography>
                              </Stack>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Fade>
              )}

              {/* Enhanced Pagination */}
              <Fade in timeout={1400}>
                <Paper sx={{ mt: 3, p: 2 }}>
                  <TablePagination
                    component="div"
                    count={totalCount}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    rowsPerPageOptions={[5, 10, 25, 50, 100]}
                    showFirstButton
                    showLastButton
                    sx={{
                      "& .MuiTablePagination-toolbar": {
                        paddingLeft: 0,
                        paddingRight: 0,
                      },
                    }}
                  />
                </Paper>
              </Fade>
            </>
          )}
        </Container>
      </Box>
    </ThemeProvider>
  );
}